export const taboolaMixins: Record<string, Partial<TaboolaProps>> = {
  //Article placements
  article_siderail_middle: {
    mode: 'thumbnails-a-stream',
    containerName: 'taboola-right-rail---8',
  },
  article_native_below_article_feed: {
    mode: 'alternating-thumbnails-a',
    containerName: 'taboola-below-article-feed',
  },
  article_content_below_button: {
    mode: 'alternating-thumbnails-a',
    containerName: 'taboola-below-article-feed',
  },
}
